<template>
    <div class="row">
        <div class="col-3 image-block">
            <logo-upload v-if="canEditMainFields()" :logo="client.clientDisplayConfig.imageLogo" ref="logoRef"/>
            <div v-else class="custom-file-input logo">
                <img :src="logoPreview" alt="" class="upload-img">
            </div>
        </div>
        <div class="col-3 image-block">
            <logo-upload v-if="canEditMainFields()" :logo="client.clientDisplayConfig.imageLogoInverse" ref="logoInverseRef" label="Dashboard Logo"/>
            <div v-else class="custom-file-input logo">
                <img :src="logoInversePreview" alt="" class="upload-img">
            </div>
        </div>
        <div class="col-3 image-block">
            <logo-upload v-if="canEditMainFields()" :logo="client.clientDisplayConfig.imageAdLogo" label="Ad Logo" ref="adLogoRef"/>
            <div v-else class="custom-file-input logo">
                <img :src="adLogoPreview" alt="" class="upload-img">
            </div>
        </div>
        <div class="col-3 image-block">
            <logo-upload v-if="canEditMainFields()" :logo="client.clientDisplayConfig.imageFavicon" label="Favicon" ref="faviconRef" />
            <div v-else class="custom-file-input logo">
                <img :src="faviconPreview" alt="" class="upload-img">
            </div>
        </div>
        <div class="col-3 image-block">
            <logo-upload v-if="canEditMainFields()" :logo="client.clientDisplayConfig.imageEmailLogoTop" label="Email Logo Top" ref="emailLogoTopRef" :subText="'(Max: 125mb JPG, PNG, GIF, SVG - Max Height 80px - Max Width 150px)'" />
            <div v-else class="custom-file-input logo">
                <img :src="emailLogoTopPreview" alt="" class="upload-img">
            </div>
        </div>
        <div class="col-3 image-block">
            <logo-upload v-if="canEditMainFields()" :logo="client.clientDisplayConfig.imageEmailLogoBottom" label="Email Logo Bottom" ref="emailLogoBottomRef" :subText="'(Max: 125mb JPG, PNG, GIF, SVG - Max Height 80px - Max Width 150px)'" />
            <div v-else class="custom-file-input logo">
                <img :src="emailLogoBottomPreview" alt="" class="upload-img">
            </div>
        </div>
        <div class="col-3 image-block">
            <logo-upload v-if="canEditMainFields()" :logo="client.clientDisplayConfig.imageLandingPageCover" label="Landing Page Cover" ref="landingPageCoverRef" :subText="'(Max: 125mb JPG, PNG, GIF, SVG - Height 1440px - Width 2560px)'" />
            <div v-else class="custom-file-input logo">
                <img :src="landingPageCoverPreview" alt="" class="upload-img">
            </div>
        </div>
    </div>
</template>

<script>
import LogoUpload from '../../../helpers/LogoUpload';

export default {
    name: 'ClientImages',
    props: ['client', 'canEditMainFields'],
    components: {
        LogoUpload
    },
    computed: {
        logoPreview: function(){
            return `${process.env.VUE_APP_CDN_URL}${this.client.clientDisplayConfig.imageLogo.location}`;
        },
        logoInversePreview: function() {
            return `${process.env.VUE_APP_CDN_URL}${this.client.clientDisplayConfig.imageLogoInverse.location}`;
        },
        adLogoPreview: function(){
            return `${process.env.VUE_APP_CDN_URL}${this.client.clientDisplayConfig.imageAdLogo.location}`;
        },
        faviconPreview: function(){
            return `${process.env.VUE_APP_CDN_URL}${this.client.clientDisplayConfig.imageFavicon.location}`;
        },
        emailLogoTopPreview: function(){
            return `${process.env.VUE_APP_CDN_URL}${this.client.clientDisplayConfig.imageEmailLogoTop.location}`;
        },
        emailLogoBottomPreview: function(){
            return `${process.env.VUE_APP_CDN_URL}${this.client.clientDisplayConfig.imageEmailLogoBottom.location}`;
        },
        landingPageCoverPreview: function(){
            return `${process.env.VUE_APP_CDN_URL}${this.client.clientDisplayConfig.imageLandingPageCoverPreview.location}`;
        }
    }
}
</script>
